import { fromJS } from 'immutable';

import {
  SET_TOKEN,
  VALUE_CHANGED,
  TOGGLE_MODAL,
  SET_REQUIRE_VERIFICATION_CODE,
  SET_USER_NAME,
  RESET_AUTHENTICATION_INFO,
  LOADING,
  SET_PURCHASE_DATE,
} from './constants';
import { API_FAIL } from '../App/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    policyNumber: '',
    email: '',
    name: '',
    urlToRedirect: 'http://localhost:3000/nextStep',
    verificationCode: 0,
    requireVerificationCode: false,
  },
  modalState: false,
  error: null,
  loading: false,
  authToken: '',
  FNOLPurchaseDate: '',
});
//
function oauthReducer(state = initialState, action) {
  const properties = (action.propertyName) ? action.propertyName.split('.') : '';
  switch (action.type) {
    case SET_TOKEN:
      return state.set('authToken', action.authToken);
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case TOGGLE_MODAL:
      return state.merge({
        error: null,
        modalState: !state.get('modalState'),
      });
    case API_FAIL:
      return state.merge({
        error: action.error,
        modalState: !state.get('modalState'),
      });
    case SET_REQUIRE_VERIFICATION_CODE:
      return state.setIn(['form', 'requireVerificationCode'], action.require);
    case SET_USER_NAME:
      return state.setIn(['form', 'name'], action.name);
    case SET_PURCHASE_DATE:
      return state.set('FNOLPurchaseDate', action.purchaseDate);
    case RESET_AUTHENTICATION_INFO:
      return initialState;
    case LOADING: {
      return state.set('loading', action.status);
    }
    default:
      return state;
  }
}

export default oauthReducer;



// WEBPACK FOOTER //
// ./app/containers/Login/reducer.js